module.exports = __webpack_public_path__ + "8fdaff658d692179ddef1e80846f84c4.png";